module.exports = __webpack_public_path__ + "static/word-travel-725a1dc080c2fbdc37541129e1442021.jpg";